import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { CallLogCountModel } from 'src/app/shared/models/calllog.model';
import { CallLogService } from 'src/app/shared/services/calllog.service';
import * as _ from 'lodash';
import { MatRadioChange } from '@angular/material';

@Component({
  selector: 'app-calllog-chart',
  templateUrl: './calllog-chart.component.html',
  styleUrls: ['./calllog-chart.component.css']
})
export class CalllogChartComponent implements OnInit {


  public lineChartData: ChartDataSets[] = [
    { data: [], label: 'Count' },
  ];
  public lineChartLabels: Label[]; // = ['09/15/2020', '09/17/2020', '09/18/2020', '09/19/2020', '09/20/2020', '09/21/2020'];
  
 /*
  public lineChartOptions: (ChartOptions & { annotation: any }) = {
   responsive: true,
  };*/
  public lineChartOptions = {
    responsive: true,
    borderWidth : 1,
    elements: {
      line: {
          tension: 0
      }
  }
    
   };
  public lineChartColors: Color[] = [
    {
      borderColor: 'gray',
      backgroundColor: 'rgba(255,0,0,0.3)',
    },
  ];
  public lineChartLegend = false;
  public lineChartType = 'line';
  public lineChartPlugins = [];

  thisData : CallLogCountModel[];
  isWeek : true;
  selected  = "1";

  constructor(private service : CallLogService) { }

  ngOnInit() {
    this.refreshData(this.selected);
  }

  refreshData(value){

    if(value == "1")
    {
      this.service.getCallLogByWeek().subscribe(
        res=>{
          this.thisData = res as CallLogCountModel[];
          this.setChartData(this.thisData);
        },
        err => {
  
        }
      );
    }
    else{
      this.service.getCallLogByMonth().subscribe(
        res=>{
          this.thisData = res as CallLogCountModel[];
          this.setChartData(this.thisData);
        },
        err => {
  
        }
      );  
    }
  
  }

  setChartData(data : CallLogCountModel[])
  {
    this.lineChartData[0].data = data.map(x => x.count);
    this.lineChartLabels = data.map(x => new Date(x.year + "-" +  x.month + "-" +  x.day).toLocaleDateString('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    }) ); 
  }

  radioChange($event: MatRadioChange) {
    console.log($event.source.name, $event.value);
    this.selected = $event.value;
    this.refreshData( this.selected);
  }

}
